import { PRESENTATION_PRONUNCIATION_DAILY_FREE_TOTAL } from 'src/apps/LearningSession/Common/learnableCards/PresentationLearnableCard/PronunciationPractice/presentationPronunciationAttempts';

/**
 * Daily free word allowance for the `review_classic` feature token.
 * The availability API only reports whether the token can still be used, so the
 * plans page reads the cap from here rather than from a sentence.
 */
export const REVIEW_CLASSIC_FREE_WORDS_PER_DAY = 50;

/** Feature token that meters classic review words for the blob experience. */
export const REVIEW_CLASSIC_BLOB_EXPERIENCE_TOKEN = 'review_classic_blob_experience' as const;

/**
 * Daily free attempts for the `presentation_screen_pronunciation` feature token.
 * Same total the lesson uses when it meters that token.
 */
export const PRESENTATION_SCREEN_PRONUNCIATION_FREE_ATTEMPTS_PER_DAY =
  PRESENTATION_PRONUNCIATION_DAILY_FREE_TOTAL;
